import { Decimal } from "decimal.js";
export const TEN = new Decimal(10);
export const ZERO = new Decimal(0);
export const NEGATIVE_ZERO = new Decimal(-0);
